/*
 * Copyright Evollis 2022
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { TENANTS } from "../../../constants"

/* Utils */
import { loc } from "../../../core/utils"
import Select from "../../../form/Select"

/* Forms controls & validation */
import TextField from "../../../form/TextField"
import Bloc from "./Bloc"
import React from "react"
import { Col, Row } from "react-bootstrap"

export default function MyAddressesBloc(props) {
  const { tunnelData, blocFields, completedFields } = props
  const { clientPageConfiguration, tenant } = tunnelData
  const { company } = clientPageConfiguration

  return (
    <Bloc hide={!company} name={"Adresses"} completedFields={completedFields} totalFieldsNumber={blocFields.length}>
      <div className="hard-shadow-white-block">
        <Row>
          <Col lg={12}>
            <TextField
              name="myAddresses.shippingAddress"
              label={loc`Shipping address`}
              trimOnBlur={true}
              disabled={true}
            />
          </Col>
          <Col lg={12}>
            <TextField
              name="myAddresses.shippingAddressComplement"
              label={loc`Shipping address 2`}
              trimOnBlur={true}
              disabled={
                tunnelData.data.order.simplifiedJourneyEnabled &&
                !tunnelData?.simplifiedJourneyInputConfiguration?.myAddresses?.shippingAddressComplement.editable
              }
            />
          </Col>
          <Col lg={4}>
            <TextField name="myAddresses.zipShippingAddress" label={loc`Zip`} inputmode="numeric" disabled={true} />
          </Col>
          <Col lg={8}>
            <Select name="myAddresses.cityShippingAddress" label={loc`City`} disabled={true} enableMatchLabel={true} />
          </Col>

          <Col lg={12} className={tenant === TENANTS.BPLS ? "mt-4" : ""}>
            <TextField
              name="myAddresses.billingAddress"
              label={loc`Billing adress`}
              trimOnBlur={true}
              disabled={true}
            />
          </Col>
          <Col lg={12}>
            <TextField
              name="myAddresses.billingAddressComplement"
              label={loc`Billing address 2`}
              trimOnBlur={true}
              disabled={
                tunnelData.data.order.simplifiedJourneyEnabled &&
                !tunnelData?.simplifiedJourneyInputConfiguration?.myAddresses?.billingAddressComplement.editable
              }
            />
          </Col>
          <Col lg={4}>
            <TextField name="myAddresses.zipBillingAddress" label={loc`Zip`} inputmode="numeric" disabled={true} />
          </Col>
          <Col lg={8}>
            <Select name="myAddresses.cityBillingAddress" label={loc`City`} disabled={true} enableMatchLabel={true} />
          </Col>
        </Row>
      </div>
    </Bloc>
  )
}
